import { createSelector } from 'reselect';

const list = state => state.trainingPrograms.list;
const selectedGuid = state => state.trainingPrograms.selectedTPGuid;

const selectedTP = createSelector(
  [list, selectedGuid],
  (trainingPrograms, tPGuid) => {
    const selected = !trainingPrograms ? null : trainingPrograms.find((trainingProgram) => {
      return trainingProgram.guid === tPGuid;
    });
    return !selected ? null : selected;
  },
);

export default { selectedTP };
